import { Quote, Star } from "lucide-react";
import { TESTIMONIALS, BIZ } from "../data";
import Reveal from "../components/Reveal";

export default function Testimonials() {
  return (
    <section className="relative overflow-hidden bg-[#080808] py-24 sm:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
          <div className="max-w-2xl">
            <Reveal>
              <span className="font-display text-sm font-semibold uppercase tracking-[0.35em] text-[--gold]">
                Depoimentos
              </span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-4 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-6xl">
                Resultados que <span className="text-[--gold]">falam</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <div className="flex items-center gap-3 border border-[--gold]/25 bg-white/5 px-5 py-3">
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-[--gold] text-[--gold]" />
                ))}
              </div>
              <span className="font-display text-sm font-bold uppercase tracking-wider text-white">
                {BIZ.rating.score} · {BIZ.rating.count} avaliações
              </span>
            </div>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-2">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={i} delay={(i % 2) * 0.08}>
              <figure className="group flex h-full flex-col border border-[--gold]/15 bg-black p-8 transition-colors duration-300 hover:border-[--gold]/50">
                <Quote className="h-8 w-8 text-[--gold]" />
                <blockquote className="mt-5 text-lg leading-relaxed text-neutral-200">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-2">
                  <span className="h-px w-8 bg-[--gold]" />
                  <span className="font-display text-sm font-semibold uppercase tracking-widest text-[--gold]">
                    {t.tag}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-sm leading-relaxed text-neutral-500">
            Relatos inspirados em avaliações reais de alunos do studio.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
